<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="keepRoot"/>
    </keep-alive>
    <router-view v-if="!keepRoot"/>
  </div>
</template>

<script>
/**
 * 根组件。Index 里的页面始终走同一个 router-view，
 * Tab 切换时壳子保持不动，三个慢页面的缓存由 Index 里的 keep-alive 保管。
 * 登录等壳子外页面仍走另一个 router-view。
 */
export default {
  name: 'App',
  computed: {
    keepRoot() {
      const top = this.$route.matched[0]
      if (top && top.name === 'Index') return true
      return !!this.$route.meta.keepAlive
    }
  }
}
</script>
<style lang="less">
@import '~@/assets/base.less';

.van-nav-bar {
  background: @color;
  background-image: linear-gradient(234deg, #D32F2F 0%, #1A1A1A 100%);

  /deep/ .van-nav-bar__title {
    color: #fff;
  }

  /deep/ .van-nav-bar__text {
    color: #fff;
  }

  /deep/ .van-nav-bar__arrow {
    color: #fff;
  }
}


.tab-project-wrap {
  background-color: #ffffff;
  box-shadow: 0rem 0.01rem 0.13rem 0rem rgba(211, 47, 47, 0.11);
  display: flex;
  align-items: center;
  justify-content: space-around;

  .item {
    font-size: 0.4rem;
    color: #666666;
    height: 1.25rem;
    line-height: 1.25rem;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -.32rem;
      width: 0.64rem;
      height: 0.08rem;
      background-color: @color;
      border-radius: 0.03rem;
      display: none;
    }

    &.active {
      color: @color;

      &:after {
        display: block;
      }
    }
  }
}


.gc-page-project-wrap {
  padding-bottom: 0.3rem;

  .box {
    margin: .28rem .28rem 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    line-height: 2;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
    border-radius: 0.27rem;

    .item {
      display: flex;
      padding: .4rem 0;
      border-top: 1PX solid #eee;
      font-size: 0.37rem;
      color: #666666;

      &:first-child {
        border-top: none;
      }

      span {
        width: 2.3rem;
        flex: 0 0 2.3rem;
        // font-size: 0.4rem;
        color: #333333;
      }

      .img {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 5px;
        margin-bottom: 5px;
      }

      .b {
        width: 0.56rem;
        height: 0.56rem;
        line-height: 0.56rem;
        background: #D32F2F;
        border-radius: 100%;
        text-align: center;
        font-size: 0.3rem;
        font-weight: normal;
        color: #fff;

        &.i1 {
          background: #B71C1C;
        }

        &.i2 {
          background: #1A1A1A;
        }
      }
    }

    .tip {
      margin-top: 0.3rem;
      min-height: 3rem;
      background-color: #f0f0f0;
      border-radius: 0.13rem;
      line-height: 1.6;
      padding: .2rem .3rem;
      font-size: 0.37rem;
      color: #666666;
    }
  }

  .page-member-wrap {
    padding-top: .5rem;
    padding-bottom: .5rem;
    // padding-right: 0.3rem;
    text-align: center;
    position: relative;
    // &:after{
    //     content: '';
    //     position: absolute;
    //     left: 46%;
    //     top: 0.5rem;
    //     bottom: 0.5rem;
    //     width: 1PX;
    //     background: #eee;
    // }
    .s1 {
      width: 46%;
      padding-right: 5%;
      text-align: left;
    }

    .s2 {
      width: 27%;
      display: flex;
      justify-content: space-around;
      align-items: flex-start;

      .btn {
        line-height: 1;
        padding: .1rem .13rem;
        font-size: 0.3rem;
        border-radius: 0.13rem;
        border: solid 1PX #D32F2F;

        &.btn1 {
          color: #D32F2F;
        }

        &.btn2 {
          color: #fff;
          background-color: #D32F2F;
        }

        &.dis {
          border-color: #ddd;
          background-color: #ddd;
          color: #333;
        }
      }
    }

    .title {
      display: flex;
      margin-bottom: 0.2rem;
      font-size: 0.37rem;
      color: #333333;
      justify-content: space-between;
    }

    .info-wrap {
      font-size: 0.3rem;
      color: #666666;

      .info-item {
        margin-top: 0.2rem;
        display: flex;
        justify-content: space-between;
      }
    }

    .input-wrap {
      position: relative;
      width: 1.3rem;
      width: 80%;
      margin-left: auto;
      margin-right: auto;

      .input {
        width: 100%;
        text-align: center;
        line-height: 1;
        padding: 0.1rem .6rem .1rem 0.13rem;
        background-color: #f0f0f0;
        border-radius: 0.13rem;
        font-size: 0.3rem;
        color: #666666;
        text-align: center;
        border: solid 1PX #f0f0f0;
      }

      i {
        position: absolute;
        right: .2rem;
        top: 0.12rem;
        font-size: 0.3rem;
        font-style: normal;
      }
    }
  }

  .page-jindu-wrap {
    padding-top: .5rem;
    padding-bottom: 1rem;

    .title {
      font-size: 0.37rem;
      color: #333333;
    }
  }

  .jindu-slider {
    margin-top: 0.7rem;
    opacity: 1;

    /deep/ .custom-button {
      position: relative;
      font-size: 0.28rem;
      color: #666666;
      width: 0.39rem;
      height: 0.39rem;
      border-radius: 100%;
      background-color: #D32F2F;
      box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.4);

      span {
        position: absolute;
        bottom: -0.7rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .submit-btn {
    width: 8.8rem;
    margin: 1rem auto .2rem;
    height: 1.04rem;
    line-height: 1.04rem;
    background-color: #D32F2F;
    box-shadow: 0rem 1PX 0.09rem 0rem rgba(26, 26, 26, 0.29);
    border-radius: 0.2rem;
    font-size: 0.47rem;
    color: #ffffff;
    text-align: center;

    &.dis {
      background: #ccc;
      box-shadow: none;
    }
  }

  .review-btn {
    margin-top: 1rem;
    margin-bottom: 0.2rem;
    display: flex;
    justify-content: space-around;

    .btn {
      width: 4rem;
      padding: .16rem 0;
      border-radius: 0.2rem;
      border: solid 0.03rem #D32F2F;
      border-radius: 0.2rem;
      text-align: center;
      font-size: 0.47rem;

      &.btn1 {
        color: #D32F2F;
      }

      &.btn2 {
        box-shadow: 0rem 0.01rem 0.09rem 0rem rgba(26, 26, 26, 0.29);
        background-color: #D32F2F;
        color: #ffffff;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue